<template>
  <layout>
    <div class="page">
      Not Found!
    </div>
  </layout>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: '404 | Nathan Nankirvis',
      meta: [
        {
          name: 'description',
          content:
            'Welcome to the studio of Australian artist and designer Nathan Nankervis.',
        },
      ],
    }
  },
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/pages/NotFound.vue